/*
 * pdp-zoom.js — make tapping the product image (or the magnifier) open the lightbox.
 *
 * Dawn only wires an invisible full-image overlay (.product__media-toggle::after)
 * to open the lightbox; the visible magnifier icon (.product__media-icon) is just
 * decorative. Worse, on this store Variant Swatch King (ymq) overlays the main
 * gallery image and eats the tap, so clicking the image did nothing on desktop
 * AND mobile. Here we delegate a CAPTURE-phase tap anywhere on an image opener
 * (.product__modal-opener--image) — the icon, the toggle, or the image itself —
 * straight to <product-modal>.show(), and stop propagation so King's handler and
 * the modal's own "pointerup-to-close" can't cancel the same gesture. A swipe is
 * a drag (no 'click') so the gallery slider still swipes. Works for touch + mouse.
 */
(function () {
  function openFrom(target) {
    var opener = target.closest('modal-opener.product__modal-opener');
    if (!opener) return false;
    var sel = opener.getAttribute('data-modal');
    if (!sel) return false;
    var modal = document.querySelector(sel);
    if (!modal || typeof modal.show !== 'function') return false;
    var btn = opener.querySelector('.product__media-toggle') || opener.querySelector('button');
    if (!btn) return false;
    modal.show(btn);
    return true;
  }

  // Capture phase so we run before any slider/pointer handlers (or King's overlay)
  // that might eat the tap. Match the whole image opener so a tap on the image
  // itself — not just the tiny magnifier icon — opens the lightbox.
  document.addEventListener(
    'click',
    function (event) {
      var hit = event.target.closest(
        '.product__modal-opener--image, .product__media-icon, .product__media-toggle'
      );
      if (!hit) return;
      if (openFrom(hit)) {
        event.preventDefault();
        event.stopPropagation();
      }
    },
    true
  );
})();
